module.exports = __webpack_public_path__ + "static/cocoa_cake_slika4-29175ab060f9dd1959e6e249f00443a2.jpg";